import React from "react";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme) => ({
  expandMoreIcon: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(0.5),
    borderRadius: "100%",
    width: theme.spacing(2),
    height: theme.spacing(2),
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 5
  },
  expandMoreIconVerticalCentreLine: {
    "&::after": {
      width: theme.spacing(0.25),
      height: theme.spacing(),
      content: '""',
      backgroundColor: theme.palette.primary.contrastText,
      position: "absolute",
      borderRadius: theme.custom.defaultBorderRadius
    }
  },
  expandMoreIconHorizontalCentreLine: {
    "&::before": {
      display: "block",
      width: theme.spacing(),
      height: theme.spacing(0.25),
      content: '""',
      top: "0.5em",
      left: "0.25em",
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: theme.custom.defaultBorderRadius
    }
  }
}));
function ExpandMorePlusIcon() {
  const { classes, cx } = useStyles();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(classes.expandMoreIconVerticalCentreLine, classes.expandMoreIconHorizontalCentreLine, classes.expandMoreIcon)
    }
  );
}
function ExpandMoreMinusIcon() {
  const { classes, cx } = useStyles();
  return /* @__PURE__ */ React.createElement("div", { className: cx(classes.expandMoreIconHorizontalCentreLine, classes.expandMoreIcon) });
}
export {
  ExpandMoreMinusIcon,
  ExpandMorePlusIcon
};
//# sourceMappingURL=ExpandMoreIcon.js.map
